// extracted by mini-css-extract-plugin
export var colorSwatch = "style-mod--color-swatch--567ff";
export var colorsVariants = "style-mod--colors-variants--efb99";
export var desktopVersion = "style-mod--desktop-version--b55ec";
export var mobileVersion = "style-mod--mobile-version--d79e1";
export var multiple = "style-mod--multiple--db5f0";
export var notSelectedColor = "style-mod--not-selected-color--142ba";
export var selected = "style-mod--selected--f22da";
export var selectedVariantText = "style-mod--selected-variant-text--a909a";
export var singleCategory = "style-mod--single-category--7467a";
export var singleVariant = "style-mod--single-variant--f36b3";
export var smallFonts = "style-mod--small-fonts--55006";
export var swatchLabel = "style-mod--swatch-label--170f6";
export var swatchList = "style-mod--swatch-list--a39d8";
export var swatchTitle = "style-mod--swatch-title--6c7a2";
export var threeVariantsRow = "style-mod--three-variants-row--51d3c";
export var variantIsSelected = "style-mod--variant-is-selected--b5fb8";